import { BaseComponent } from './base.component';
import { AfterViewInit, Directive, signal, ViewChild } from '@angular/core';
import { IPagination } from '../../../interfaces/IPagination';
import { finalize, Observable } from 'rxjs';
import { IResponse } from '../../../interfaces/IResponse';
import { IPagedResults } from '../../../interfaces/IPagedResults';
import { ApiErrorResponse } from '../../../classes/ApiErrorResponse';
import { INoDataResponse } from '../../../interfaces/INoDataResponse';
import { PagedTableComponent } from '../../../../shared/components/paged-table/paged-table.component';

@Directive()
export abstract class BasePagedTableComponent<T> extends BaseComponent implements AfterViewInit {

  @ViewChild(PagedTableComponent) pagedTabledComponent: PagedTableComponent<T>;

  public pagination: IPagination = {
    page: 1,
    results: 10,
    totalResults: 0
  };
  public data: T[];
  public readonly isLoading = signal(false);

  public ngAfterViewInit(): void {
    this.pagedTabledComponent.basePagedTableComponent = this;
    this.pagedTabledComponent.cdr.detectChanges();
    this.loadData();
  }

  public loadData(resetPagination = false): void {
    if (resetPagination) {
      this.pagination.page = 1;
    }

    this.isLoading.set(true);
    this.pagedTabledComponent.cdr.detectChanges();

    this.data$
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: res => {
          this.pagination = res.data.info;
          this.data = res.data.results;
          this.cdr.detectChanges();
          this.pagedTabledComponent.cdr.detectChanges();
          this.onDataLoadedSuccess();
        },
        error: ({ error }: ApiErrorResponse) => this.onDataLoadedError(error)
      });
  }

  protected abstract get data$(): Observable<IResponse<IPagedResults<T>>>;

  protected onDataLoadedSuccess(): void {}

  protected onDataLoadedError(error: INoDataResponse): void {
    this.notificationService.pushError(
      'Fehler'.trans('notifications/error.Title'),
      'Error during loading data.'.trans(`notifications/load-data-error/.Message`)
    );
  }
}
